const TELEGRAM_BOT_URL_PATTERN =
  /^https:\/\/(t\.me|telegram\.me)\/[^/?#\s]+\/?$/i;

export function isValidTelegramBotUrl(url) {
  if (url == null || String(url).trim() === "") {
    return true;
  }
  return TELEGRAM_BOT_URL_PATTERN.test(String(url).trim());
}

export function getTelegramBotBaseUrl(telegramBotUrl) {
  if (!telegramBotUrl) {
    return null;
  }
  const trimmed = String(telegramBotUrl).trim();
  const match = trimmed.match(/(?:https?:\/\/)?(?:t\.me|telegram\.me)\/([^/?#\s]+)/i);
  if (match) {
    return `https://t.me/${match[1]}`;
  }
  if (TELEGRAM_BOT_URL_PATTERN.test(trimmed)) {
    return trimmed.replace(/\/$/, "");
  }
  return null;
}

export function buildTelegramBindDeepLink(telegramBotUrl, bindCode, subDomain) {
  const baseUrl = getTelegramBotBaseUrl(telegramBotUrl);
  if (!baseUrl || !bindCode || !subDomain) {
    return baseUrl;
  }
  const startPayload = `bind_${bindCode}_${subDomain}`;
  return `${baseUrl}?start=${encodeURIComponent(startPayload)}`;
}

export function getTelegramBotDisplay(telegramBotUrl) {
  if (!telegramBotUrl) {
    return null;
  }
  const match = String(telegramBotUrl).match(/(?:t\.me|telegram\.me)\/([^/?]+)/i);
  if (match) {
    return `@${match[1]}`;
  }
  return telegramBotUrl;
}

export function getTelegramBotName(telegramBotUrl) {
  const display = getTelegramBotDisplay(telegramBotUrl);
  if (!display) {
    return null;
  }
  return display.startsWith("@") ? display.slice(1) : display;
}
